<script setup lang="ts">
import {default as templateStore} from "@/store";
import MainPageMobileVersion from "@/components/MainPage/MobileVersion.vue";
import MainPagePcVersion from "@/components/MainPage/PcVersion.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'MainPage',
})
</script>

<template>
    <MainPagePcVersion v-if="templateStore.state.pageSize.width > templateStore.state.mobileVersionThresholdWidth"/>
    <MainPageMobileVersion v-else/>
</template>

<style scoped lang="scss">
</style>
